import { enMonths, frMonths } from './Constants';

const getHourAndMinute = function (date: Date) {
  return `${String(date.getHours()).padStart(2, '0')}:${String(date.getMinutes()).padStart(2, '0')}`;
};

const displayingDate = function (date: Date, language: string, NumberOnly: boolean, displayHour = true): string {
  let res = '';
  if (NumberOnly) {
    if (language === 'en-US') {
      res += `${date.getFullYear()}/${String(date.getMonth() + 1).padStart(2, '0')}/${String(date.getDate()).padStart(2, '0')}`;
    } else {
      res += `${String(date.getDate()).padStart(2, '0')}/${String(date.getMonth() + 1).padStart(2, '0')}/${date.getFullYear()}`;
    }
  } else {
    if (language === 'en-US') {
      res += `${date.getFullYear()} ${enMonths[date.getMonth()]} ${date.getDate()}`;
    } else {
      res += `${date.getDate()} ${frMonths[date.getMonth()]} ${date.getFullYear()}`;
    }
  }
  if (displayHour) {
    if (language === 'en-US') {
      res += ` at ${getHourAndMinute(date)}`;
    } else {
      res += ` à ${getHourAndMinute(date)}`;
    }
  }
  return res;
};

export { displayingDate };
